import React, { useEffect } from "react";
import { withStyles, Slide } from "@material-ui/core";
import { withTranslation } from "react-i18next";
import { images } from "../utils/images";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

function NotFoundContainer(props) {
  const { classes, t } = props;

  // ComponentDidMount
  useEffect(() => {
    document.body.style.background = "#262626";

    return () => {
      document.body.style.background = "#262626";
    };
  }, []);

  return (
    <div style={{ paddingTop: 80 }}>
      <div className={classes.soloLogo}>
        <img src={images.logos.sologenicWhiteLogo} />
      </div>
      <Slide in direction="left">
        <div className={classes.documentReview}>
          <div className="contentDoc">
            <h2>{t("_404")}</h2>
            <p>{t("_notFound")}</p>

            <Link to="/id/settings" className="goToBtn">
              {t("_goToSettings")}
            </Link>
          </div>
          <img src={images.illustrations.notFound} />
        </div>
      </Slide>
    </div>
  );
}

function mapStateToProps(state) {
  return {};
}

const styles = (theme) => ({
  soloLogo: {
    width: "100%",
    height: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    position: "relative",
    "& img": {
      width: 180,
      height: "auto",
    },
  },
  documentReview: {
    width: "95%",
    maxWidth: 900,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 80,
    color: theme.colors.text.primary,
    background: theme.colors.background.fore,
    boxShadow: theme.defaults.shadow,
    borderRadius: 4,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    overflow: "hidden",
    padding: "40px 40px 40px 80px",
    [theme.breakpoints.down(600)]: {
      padding: 24,
    },
    "& contentDoc": {
      width: "55%",
    },
    "& img": {
      // position: "absolute",
      // right: 0,
      // top: 0,
      width: "35%",
      height: "auto",
      objectFit: "contain",
      // transform: "translate(35%, -12%)",
      [theme.breakpoints.down(600)]: {
        display: "none",
      },
    },

    "& h2": {
      fontSize: 48,
      fontWeight: 700,
      zIndex: 2,
      [theme.breakpoints.down(600)]: {
        fontSize: 32,
      },
    },
    "& p": {
      fontSize: 24,
      // fontFamily: "Titillium Web",
      marginTop: 32,
      marginBottom: 64,
      lineHeight: "32px",
      width: "85%",
      zIndex: 2,
      fontWeight: 600,
    },
    "& a": {
      background: theme.colors.background.active,
      borderRadius: 2,
      color: theme.colors.text.textOnRed,
      textDecoration: "none",
      transition: ".3s",
      width: 220,
      fontSize: 18,
      height: 45,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 600,
      // fontFamily: "Titillium Web",
      zIndex: 2,
      "&:hover": {
        opacity: 0.5,
      },
    },
  },
});

export default withStyles(styles)(
  withTranslation()(connect(mapStateToProps, null)(NotFoundContainer))
);
